import './LeftRightSelect.less';
import React from 'react';
import Spinner from '../spinner/Spinner';
import {translate} from "../../i18n";
import Icon from "../icon/Icon";

export default class LeftRightSelect extends React.Component {
    // props.sortable is not supported yet

    constructor(props) {
        super(props);

        this.state = {
            selectedItems: []
        };
        this.pendingSearchQuery = null;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.autoUpdateSearchIfHasPendingSearchQuery(nextProps);
    }

    componentDidMount() {
        this.setLeftItemsViewOnScroll();
        this.setSelectedItemsByDefault();
    }

    componentDidUpdate() {
        this.autoCallScrollBottomIfScrollContentTooShort();
    }

    autoUpdateSearchIfHasPendingSearchQuery = (nextProps) => {
        if (!nextProps.isItemsLoading && this.props.isItemsLoading) {
            if (this.pendingSearchQuery !== null && this.pendingSearchQuery !== nextProps.searchQuery) {
                this.updateSearch(this.pendingSearchQuery);
            }
        }
    };

    autoCallScrollBottomIfScrollContentTooShort = () => {
        const scrollView = this.leftItemsView;
        const {onLeftItemsViewScrollBottom, itemsLoadingError} = this.props;
        if (itemsLoadingError === null && this.pendingSearchQuery === null) {
            if (scrollView.scrollHeight === scrollView.clientHeight) {
                onLeftItemsViewScrollBottom && onLeftItemsViewScrollBottom();
            }
        }
    };

    setLeftItemsViewOnScroll = () => {
        const scrollView = this.leftItemsView;
        scrollView.addEventListener('scroll', () => {
            const {onLeftItemsViewScrollBottom} = this.props;
            if (scrollView.clientHeight + scrollView.scrollTop > scrollView.scrollHeight - 2) {
                onLeftItemsViewScrollBottom && onLeftItemsViewScrollBottom();
            }
        });
    };

    updateSearch = (query) => {
        if (this.updateSearchTimer) {
            clearTimeout(this.updateSearchTimer);
        }
        this.updateSearchTimer = setTimeout(() => {
            const {updateSearch, isItemsLoading} = this.props;
            if (isItemsLoading) {
                this.pendingSearchQuery = query;
            } else {
                const scrollView = this.leftItemsView;
                if (scrollView) {
                    scrollView.scrollTop = 0;
                }
                this.pendingSearchQuery = null;
                updateSearch && updateSearch(query);
            }
        }, 300);
    };

    setSelectedItemsByDefault() {
        const {defaultSelectedItems, updateSelectedItems} = this.props;
        if (defaultSelectedItems && defaultSelectedItems.length > 0) {
            this.setState({
                selectedItems: JSON.parse(JSON.stringify(defaultSelectedItems))
            }, () => {
                updateSelectedItems && updateSelectedItems(JSON.parse(JSON.stringify(this.state.selectedItems)));
            });
        }
    }

    selectItem = (item) => {
        const {selectedItems} = this.state;
        const {updateSelectedItems} = this.props;
        if (selectedItems.find(_item => _item.id === item.id)) {
            return;
        }
        selectedItems.push(item);
        this.setState({selectedItems}, () => {
            updateSelectedItems && updateSelectedItems(JSON.parse(JSON.stringify(selectedItems)));
        });
    };

    deselectItem = (itemId) => {
        const {selectedItems} = this.state;
        const {updateSelectedItems} = this.props;
        let itemIndex = null;
        selectedItems.some((item, index) => {
            if (item.id === itemId) {
                itemIndex = index;
                return true;
            }
            return false;
        });
        if (itemIndex !== null) {
            selectedItems.splice(itemIndex, 1);
        }
        this.setState({selectedItems}, () => {
            updateSelectedItems && updateSelectedItems(JSON.parse(JSON.stringify(selectedItems)));
        });
    };

    deselectAllItems = () => {
        const {updateSelectedItems} = this.props;
        const selectedItems = [];
        this.setState({selectedItems}, () => {
            updateSelectedItems && updateSelectedItems(JSON.parse(JSON.stringify(selectedItems)));
        });
    };

    render() {
        const {items, renderItemContent, getItemIsDisabled, updateSearch, isItemsLoading, itemsLoadingError, disabled: inputDisabled} = this.props;
        const {selectedItems} = this.state;

        const isItemsEmpty = items.length === 0 && !isItemsLoading && !itemsLoadingError;
        const isSelectedItemsEmpty = selectedItems.length === 0;

        return <div className={'left-right-select' + (inputDisabled ? ' disabled' : '')}>
            <table>
                <thead>
                <tr>
                    <td className="left" onClick={() => this.searchInput.focus()}>
                        {
                            updateSearch &&
                            <div className="search-box">
                                <input
                                    type="text"
                                    onKeyUp={event => this.updateSearch(event.target.value)}
                                    onChange={event => this.updateSearch(event.target.value)}
                                    onPaste={event => this.updateSearch(event.target.value)}
                                    ref={el => this.searchInput = el}
                                />
                                <Icon name="search"/>
                            </div>
                        }
                    </td>
                    <td className="right">
                        <div className="selected-heading">
                            <div className="title">
                                {translate('Selected (::number)', {number: selectedItems.length})}
                            </div>
                            {
                                selectedItems.length > 0 &&
                                <button type="button" className="deselect-all-button" onClick={this.deselectAllItems}>
                                    {translate('Deselect all')}
                                </button>
                            }
                        </div>
                    </td>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="left">
                        <div className="items-view">
                            <div className={'items' + (isItemsEmpty ? ' empty' : '')}
                                 ref={el => this.leftItemsView = el}
                            >
                                <ul>
                                    {
                                        items.map(item => {
                                            const selected = !!selectedItems.find(_item => _item.id === item.id);
                                            const disabled = getItemIsDisabled && getItemIsDisabled(item);
                                            return <li
                                                key={item.id}
                                                onClick={() => inputDisabled || disabled || this.selectItem(item)}
                                                className={(selected ? ' selected' : '')
                                                    + (disabled ? ' disabled' : '')
                                                }
                                            >
                                                <div className="item-inner">{renderItemContent(item, disabled)}</div>
                                                <button type="button" className="select-button">
                                                    <Icon name="arrow-right"/>
                                                </button>
                                            </li>;
                                        })
                                    }
                                </ul>
                            </div>
                            {
                                isItemsEmpty &&
                                <div className="items-empty-message">
                                    {translate('Empty list')}
                                </div>
                            }
                            {
                                itemsLoadingError &&
                                <div className="items-loading-error">
                                    {itemsLoadingError}
                                </div>
                            }
                            {
                                isItemsLoading &&
                                <div className="items-loading-indicator">
                                    <Spinner/>
                                    <div className="text">{translate('Loading...')}</div>
                                </div>
                            }
                        </div>
                    </td>
                    <td className="right">
                        <div className="items-view">
                            <div className={'items' + (isSelectedItemsEmpty ? ' empty' : '')}>
                                <ul>
                                    {
                                        selectedItems.map(item => {
                                            const disabled = getItemIsDisabled && getItemIsDisabled(item);
                                            return <li
                                                key={item.id}
                                                className={(disabled ? ' disabled' : '')}
                                            >
                                                <div className="item-inner">{renderItemContent(item, disabled)}</div>
                                                <button type="button" className="remove-button"
                                                        onClick={() => inputDisabled || this.deselectItem(item.id)}
                                                >
                                                    <Icon name="times"/>
                                                </button>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    }
}
